import { h, Component } from "preact";
import { Link } from "preact-router/match";
import { reduxForm, Field } from "redux-form";
import { connect } from "react-redux";

import Page from "../../components/Page";
import Content from "../../components/Content";
import ActionBar from "../../components/ActionBar";
import ActionButton from "../../components/ActionButton";
import DatesDisplay from "../../components/DatesDisplay";
import LocationStr from "../../components/LocationStr";

import InputField from "../../components/fields/InputField";
import TextareaField from "../../components/fields/TextareaField";

import { required, email } from "../../utils/Validators";
import { scrollToErrors } from "../../utils/ScrollToErrors";

import { getEvent } from "../../state/actions/eventActions";
import { sendMessage, reset } from "../../state/actions/contactActions";

import successIcon from "../../assets/images/icon-success.svg";
import { pageChange } from "../../utils/BrowserUtils";

let ContactForm = ({ contact, event, handleSubmit, sendMessage }) => {
  const save = values => {
    sendMessage(event.data._id, values);
  };
  let ticketString = "Get Tickets";
  const theme =
    event && event.data && event.data.theme ? event.data.theme : null;
  if (theme && theme.ticketButtonText) {
    ticketString = theme.ticketButtonText;
  }
  if (contact.sent) {
    return (
      <div>
        <div
          style={{
            background: `url(${successIcon}) no-repeat center`,
            backgroundSize: 120,
            padding: "170px 0 40px 0",
            textAlign: "center"
          }}
        >
          <h3>Message Sent</h3>
        </div>
        <ActionBar>
          <Link href={`/${event.data.slug}/tickets`}>
            <ActionButton>{ticketString}</ActionButton>
          </Link>
          <Link
            style={{
              padding: "18px 0px",
              display: "inline-block"
            }}
            href={`/${event.data.slug}`}
          >
            Back to Event
          </Link>
        </ActionBar>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit(save)}>
      {contact && contact.error ? (
        <p class="text-error">{contact.error.message}</p>
      ) : (
        ""
      )}
      <Field
        label="Name"
        type="text"
        name="name"
        component={InputField}
        required={true}
        validate={required}
      />
      <Field
        label="Email"
        type="email"
        name="email"
        component={InputField}
        required={true}
        validate={[required, email]}
      />

      <Field
        label="Message"
        name="message"
        component={TextareaField}
        required={true}
        validate={required}
      />
      <ActionBar>
        <ActionButton disabled={contact.loading} loading={contact.loading}>
          Submit
        </ActionButton>
        <Link
          style={{
            padding: "18px 0px",
            display: "inline-block"
          }}
          href={`/${event.data.slug}`}
        >
          Back to Event
        </Link>
      </ActionBar>
    </form>
  );
};

ContactForm = reduxForm({
  form: "contact",
  onSubmitFail: errors => {
    scrollToErrors();
  }
})(ContactForm);

ContactForm = connect(
  (state, ownProps) => ({
    event: state.event,
    contact: state.contact
  }),
  {
    sendMessage
  }
)(ContactForm);

class Contact extends Component {
  constructor() {
    super();
  }

  componentDidMount() {
    const { event, getEvent, eventSlug, orderId, reset } = this.props;
    reset();
    if (!event.data && !event.loading) {
      getEvent(eventSlug);
    }
    pageChange("Contact", event);
  }

  render({ event }) {
    if (!event || !event.data) {
      return;
    }
    return (
      <Page background={false} border={false}>
        <Content>
          <div
            class="columns event"
            style={{ height: "100%", padding: "50px 24px" }}
          >
            <div class="column col-8 col-sm-12 pad-lg event-info">
              <h1>{`Contact ${event.data.name}`}</h1>
              {() => <p />}
              {event.data.organiser ? (
                <h3>Event organiser: {event.data.organiser.name}</h3>
              ) : null}
              {event.data.organiser && event.data.organiser.description ? (
                <p>{event.data.organiser.description}</p>
              ) : null}
              <ContactForm />
            </div>
            <div class="column col-4 col-sm-12">
              <div style={{ padding: 24 }} class="box">
                <h2>FAQ</h2>
                <h4>Location</h4>
                <LocationStr location={event.data.location} />
                <h4>Dates</h4>
                <DatesDisplay
                  dates={event.data.dates}
                  eventSlug={event.data.slug}
                />
                <h4 style={{ marginTop: 18 }}>Where are my tickets</h4>

                {event.data.settings.sendTickets === false ? (
                  <p>
                    Tickets are not required to attend this event. Your
                    invoice/receipt is attached as a PDF file to your order
                    confirmation sent from orders@humanitix.com to the buyer’s
                    email address, once you have completed your purchase. If you
                    are having trouble finding them, please check your spam
                    folder or contact the organiser to resend.
                  </p>
                ) : (
                  <p>
                    Your tickets are included in your order confirmation email
                    sent from orders@humanitix.com. If you are having trouble
                    finding them please check your spam folder or contact the
                    organiser to resend.
                  </p>
                )}
              </div>
            </div>
          </div>
        </Content>
      </Page>
    );
  }
}
export default connect(
  (state, ownProps) => ({ event: state.event }),
  {
    getEvent,
    reset
  }
)(Contact);



// WEBPACK FOOTER //
// ./routes/contact/Contact.js